import { getEffectiveToken } from './storage'

export type FeedbackType = 'bug' | 'idea' | 'question'
export type FeedbackImpact = 'minor' | 'major' | 'blocking'

export const FEEDBACK_MAX_CHARS = 2000

export const FEEDBACK_TYPE_LABELS: Record<FeedbackType, string> = {
  bug: 'Something is broken',
  idea: 'I have an idea',
  question: 'Something else / a question',
}

export const FEEDBACK_IMPACT_LABELS: Record<FeedbackImpact, string> = {
  minor: 'A little',
  major: 'A lot',
  blocking: "I can't work",
}

export const FEEDBACK_STATUS_LABELS: Record<string, string> = {
  new: 'Received',
  planned: 'Planned',
  shipped: 'Shipped',
  closed: 'Closed',
}

export const FEEDBACK_RESOLUTION_LABELS: Record<string, string> = {
  answered: 'Answered',
  duplicate: 'Duplicate of an earlier item',
  wont_do: 'Not planned',
  cannot_reproduce: "We couldn't reproduce this",
}

export interface MyFeedbackRow {
  feedback_id: string
  reference: string
  type: FeedbackType
  body: string
  status: string
  resolution: string | null
  public_reply: string | null
  created_at: string
  updated_at_visible: string | null
  unread: boolean
}

/** Message length as the server counts it: Unicode code points. */
export function countChars(text: string): number {
  return Array.from(text).length
}

export interface FeedbackDraft {
  type: FeedbackType | null
  body: string
  impact: FeedbackImpact | null
  contactOk: boolean
}

const EMPTY_DRAFT: FeedbackDraft = { type: null, body: '', impact: null, contactOk: true }

// In-memory only (not localStorage): the draft lives until the page
// reloads, and is dropped when the session token changes (logout / login
// as someone else) so one person's half-written message is never shown
// to the next.
let draft: FeedbackDraft = { ...EMPTY_DRAFT }
let draftToken: string | null = null

export function loadDraft(): FeedbackDraft {
  const token = getEffectiveToken()
  if (token !== draftToken) {
    draft = { ...EMPTY_DRAFT }
    draftToken = token
  }
  return draft
}

export function saveDraft(next: FeedbackDraft) {
  draft = next
  draftToken = getEffectiveToken()
}
